var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 36.87 46.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Degradado_sin_nombre_9-2);\n      }\n\n      .cls-2 {\n        fill: url(#Degradado_sin_nombre_9);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9",
    "data-name": "Degradado sin nombre 9",
    x1: 0,
    y1: 23.03,
    x2: 36.87,
    y2: 23.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#cd882d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#cd882d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#e1b45a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#edcf75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#f2da80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#ba8432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9-2",
    "data-name": "Degradado sin nombre 9",
    x1: 17.31,
    y1: 17.27,
    x2: 28.2,
    y2: 17.27,
    xlinkHref: "#Degradado_sin_nombre_9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.25,46.06l-1.23-.21C7.52,44.38.83,35.77.08,25.11l-.08-.54.02-3.08.06-.64C.93,9.87,7.92,1.15,16.74.1l.51-.09h2.47s.43.09.43.09c8.57.94,15.5,9.25,16.65,19.87l.07.42v5.4c-1.01,10.3-7.55,18.72-15.93,20.07l-1.24.2h-2.46ZM33.95,23.03c0-10.64-6.92-19.27-15.46-19.27S3.02,12.39,3.02,23.03s6.92,19.27,15.46,19.27,15.46-8.63,15.46-19.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.72,18.87l-8.9,7.66c-.3.26-.75.23-1.05,0-.25-.18-.46-.6-.46-1.09V9.16c0-.73.33-1.23.88-1.32.45-.07,1.08.36,1.08,1.11v14.2s7.37-6.34,7.37-6.34c.47-.41,1.04-.23,1.35.28.34.55.26,1.33-.28,1.79Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloj);
export default __webpack_public_path__ + "static/media/reloj.2a317458ac9a88e5ddaf53e2cec043f4.svg";
export { ForwardRef as ReactComponent };